<template>
    <div>
        <template v-if="type=='message'">
            <message-viewer v-model="message"></message-viewer>
        </template>
        <template v-if="type=='generic'">
            <generic-viewer v-model="generics"></generic-viewer>
        </template>

    </div>
</template>

<script>
import GenericViewer from '@/components/elements/GenericViewer'
import MessageViewer from '@/components/elements/MessageViewer'
    export default {
        props: ['value'],
        data: function(){
            return {
                generics: [],
                message: '',
                type: '',
            }
        },
        components: {
            GenericViewer,
            MessageViewer
        },
        created: function(){
            var vm = this
            vm.generics = this.value.generics
            vm.message = this.value.message
            vm.type = this.value.type
        },
        methods: {
        },
        watch: {
            value: function(){
                this.generics = this.value.generics
                this.message = this.value.message
                this.type = this.value.type
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/view/intent/IntentGetstarted.vue